import {
  getCompletionGroupByOptions,
  getFormTypeOptions,
} from 'components/GenerateReportForm/utils/getFormFields';
import { FieldNames } from 'components/GenerateReportForm/types';
import { Values } from '@lib/interfaces/form';

export default function useDefaultValues(): Values {
  return {
    [FieldNames.FormType]: getFormTypeOptions()?.[0],
    [FieldNames.CompletionGroupBy]: getCompletionGroupByOptions()?.[0],
    [FieldNames.UserId]: null,
    [FieldNames.Message]: null,
    // Custom renders
    [FieldNames.Title1]: null,
    [FieldNames.Title2]: null,
    [FieldNames.Title3]: null,
    [FieldNames.ReportDetails]: null,
  };
}
